import { tariffGridQuery } from '@/entities/billing/queries';
import { TChannelProtocol } from '@/entities/channel';
import { useAppQuery } from '@/shared/lib/useAppQuery';

export function useTariffGrid(protocol?: TChannelProtocol) {
  const { data, isError, error, ...otherQueryData } = useAppQuery({
    ...tariffGridQuery({ protocol: protocol! }),
    enabled: !!protocol,
  });

  return { data, isError, error, ...otherQueryData };
}
